import { render, staticRenderFns } from "./StatInputV2.vue?vue&type=template&id=4bdab4a8&scoped=true&"
import script from "./StatInputV2.vue?vue&type=script&lang=js&"
export * from "./StatInputV2.vue?vue&type=script&lang=js&"
import style0 from "./StatInputV2.vue?vue&type=style&index=0&id=4bdab4a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdab4a8",
  null
  
)

export default component.exports